/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compliance_StatusInputs */

const en_compliance_status = /** @type {(inputs: Compliance_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compliance Status`)
};

const es_compliance_status = /** @type {(inputs: Compliance_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estado de Cumplimiento`)
};

const fr_compliance_status = /** @type {(inputs: Compliance_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statut de conformité`)
};

const de_compliance_status = /** @type {(inputs: Compliance_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compliance-Status`)
};

const id_compliance_status = /** @type {(inputs: Compliance_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status Kepatuhan`)
};

/** @type {(inputs: Compliance_StatusInputs) => LocalizedString} */
const ja_compliance_status = en_compliance_status;

/** @type {(inputs: Compliance_StatusInputs) => LocalizedString} */
const zh_compliance_status = en_compliance_status;

/** @type {(inputs: Compliance_StatusInputs) => LocalizedString} */
const ar_compliance_status = en_compliance_status;

/** @type {(inputs: Compliance_StatusInputs) => LocalizedString} */
const it_compliance_status = en_compliance_status;

/** @type {(inputs: Compliance_StatusInputs) => LocalizedString} */
const ru_compliance_status = en_compliance_status;

/** @type {(inputs: Compliance_StatusInputs) => LocalizedString} */
const pt_compliance_status = en_compliance_status;

/** @type {(inputs: Compliance_StatusInputs) => LocalizedString} */
const ko_compliance_status = en_compliance_status;

/**
* | output |
* | --- |
* | "Compliance Status" |
*
* @param {Compliance_StatusInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const compliance_status = /** @type {((inputs?: Compliance_StatusInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_StatusInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_compliance_status(inputs)
	if (locale === "es") return es_compliance_status(inputs)
	if (locale === "fr") return fr_compliance_status(inputs)
	if (locale === "de") return de_compliance_status(inputs)
	if (locale === "ja") return ja_compliance_status(inputs)
	if (locale === "zh") return zh_compliance_status(inputs)
	if (locale === "ar") return ar_compliance_status(inputs)
	if (locale === "id") return id_compliance_status(inputs)
	if (locale === "it") return it_compliance_status(inputs)
	if (locale === "ru") return ru_compliance_status(inputs)
	if (locale === "pt") return pt_compliance_status(inputs)
	return ko_compliance_status(inputs)
});